document.addEventListener('DOMContentLoaded', () => {
  // Filter Submit
  const form = document.getElementById('CollectionFiltersForm');

  if (form) {
    const minInput = form.querySelector('[data-price-min]');
    const maxInput = form.querySelector('[data-price-max]');

    const initialMin = minInput?.value.trim() || '';
    const initialMax = maxInput?.value.trim() || '';

    function submitForm() {
      [minInput, maxInput].forEach((input) => {
        if (!input) return;

        input.disabled = input.value.trim() === '';
      });

      form.submit();
    }

    // Availability + Product Type
    form.querySelectorAll('[data-auto-submit]').forEach((input) => {
      input.addEventListener('change', submitForm);
    });

    // Price
    function handlePriceSubmit() {
      const min = minInput?.value.trim() || '';
      const max = maxInput?.value.trim() || '';

      if (min === initialMin && max === initialMax) {
        return;
      }

      submitForm();
    }

    [minInput, maxInput].forEach((input) => {
      if (!input) return;

      input.addEventListener('blur', handlePriceSubmit);

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handlePriceSubmit();
        }
      });
    });
  }
  // Mobile Filter Toggle
  const button = document.querySelector('.collection-filter__mobile-toggle');
  const filter = document.querySelector('.collection-filter');

  if (button && filter) {
    const isMobile = () => window.innerWidth <= 990;

    if (isMobile()) {
      filter.style.maxHeight = '0px';
    }

    button.addEventListener('click', () => {
      if (!isMobile()) return;

      const isOpen = filter.classList.toggle('is-open');

      if (isOpen) {
        filter.style.maxHeight = filter.scrollHeight + 'px';
      } else {
        filter.style.maxHeight = '0px';
      }

      button.setAttribute('aria-expanded', isOpen);
    });

    window.addEventListener('resize', () => {
      if (!isMobile()) {
        filter.style.maxHeight = '';
        filter.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      } else if (!filter.classList.contains('is-open')) {
        filter.style.maxHeight = '0px';
      }
    });
  }
  // Accordion Animation
  document.querySelectorAll('.collection-filter__accordion').forEach((details) => {
    const content = details.querySelector('.collection-filter__content');

    if (!content) return;

    content.style.maxHeight = details.open
      ? content.scrollHeight + 'px'
      : '0px';

    details.querySelector('summary').addEventListener('click', (e) => {
      e.preventDefault();

      if (details.open) {
        content.style.maxHeight = content.scrollHeight + 'px';

        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });

        content.addEventListener(
          'transitionend',
          () => {
            details.removeAttribute('open');
          },
          { once: true }
        );

      } else {
        details.setAttribute('open', '');

        requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + 'px';
        });
      }
    });
  });

});